/* @ngInject */
const format = (utils) => {
  const self = {}

  self.user = (_train) => {
    const train = utils.copy(_train)
    if (!utils.date.isValidString(train.date)) {
      train.date = utils.date.timestampToString(train.date)
    }
    return train
  }

  self.server = (_train) => {
    const train = utils.copy(_train)
    train.date = utils.date.stringToServer(train.date)
    return train
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/format.service.js